'use client';

import React from 'react';

import SimpleBar, { Props as SimpleBarProps } from 'simplebar-react';

import 'simplebar-react/dist/simplebar.min.css';

export const Scrollbar = React.forwardRef<any, SimpleBarProps>(({ style, ...props }, ref) => (
  <SimpleBar
    {...props}
    ref={ref}
    style={{
      maxHeight: '100%',
      minHeight: 0,
      ...style,
    }}
  />
));
